import { ActiveMessagesFeatures } from './activeMessages/ActiveMessagesFeatures';
import { GrowthFeatures } from './GrowthFeatures';
import './Growth.scss';
import { GROWTH_SCHEDULER_OPENED, GROWTH_WHATSAPP_GROUPS_OPENED, GROWTH_ICEBREAKER_CLICKED } from './GrowthSegmentEvents';
import { ClickTrackerFeatures } from './clickTracker/ClickTrackerFeatures';
import { AdsBuyingFeatures } from './adsBuying/AdsBuyingFeatures';
import * as angular from 'angular';
import { GroupsFeatures } from './groups/GroupsFeatures';
import { JourneyFeatures } from './journey/JourneyFeatures';
import { JourneyConstants } from './journey/JourneyConstants';
import { AdsBuyingConstants } from './adsBuying/AdsBuyingConstants';
import { ClickTrackerConstants } from './clickTracker/ClickTrackerConstants';
import { ActiveMessagesConstants } from './activeMessages/ActiveMessagesConstants';
export class GrowthController {
    static $inject = ['application', 'GrowthSegmentService', 'SegmentService', '$translate', '$state', '$scope', 'LoadingService'];
    constructor(application, GrowthSegmentService, SegmentService, $translate, $state, $scope, LoadingService) {
        'ngInject';
        this.application = application;
        this.GrowthSegmentService = GrowthSegmentService;
        this.SegmentService = SegmentService;
        this.$translate = $translate;
        this.$state = $state;
        this.$scope = $scope;
        this.LoadingService = LoadingService;
        this.GrowthSegmentService.setApplication(this.application);
        angular.element(document).ready(() => {
            this.checkFeatures().then(() => {
                this.Init();
            });
        });
    }
    async Init() {
        this.isMenuRedesignEnabled
            ? this.initRedesignMenu()
            : await this.initLegacyMenu();
    }
    initRedesignMenu() {
        this.checkMenuOpenState();
        const mainSection = document.querySelector('#main-section');
        mainSection.classList.add('growth-menu-redesign');
        this.$scope.$on('$stateChangeSuccess', () => {
            if (this.isMenuRedesignEnabled) {
                this.checkMenuOpenState();
            }
        });
    }
    async initLegacyMenu() {
        this.$scope.$applyAsync(async () => {
            const clickTrackerTagNews = await this.$translate('growth.clicktracker.tagNews');
            const icebreakerTagNews = await this.$translate('growth.icebreaker.tagNews');
            const journeyTagNews = await this.$translate('growth.journey.tagNews');
            this.changeTag('#menu-clicktracker > li > a > span.sidebar-title > span', clickTrackerTagNews, '#35DE90');
            this.changeTag('#menu-icebreaker > li > a > span.sidebar-title > span', icebreakerTagNews);
            this.changeTag('#menu-journey > li > a > span.sidebar-title > span', journeyTagNews);
        });
    }
    goTo(state, trackName = '') {
        if (this.isActiveState(state))
            return;
        this.LoadingService.startLoading(true);
        trackName && this.menuTracking(trackName);
        this.$state.go(state);
    }
    openUrl(url, trackName = '') {
        window.open(url, '_blank');
        this.menuTracking(trackName);
    }
    menuTracking(trackName) {
        const trackEvent = `marketing-growth-${trackName}-clicked`;
        this.SegmentService.createApplicationTrack({
            trackEvent,
            application: this.application,
        });
    }
    changeTag(id, text, backgroundColor = '#b3d4ff') {
        const tag = document.querySelector(id);
        if (!tag)
            return;
        tag.innerHTML = text;
        tag.style.background = backgroundColor;
    }
    checkMenuOpenState() {
        this.isOpenStateMap = {
            journey: this.isActiveState(JourneyConstants.JOURNEY_CAMPAIGNS_STATE),
            sendactiveMessage: this.isActiveState(ActiveMessagesConstants.SEND_ACTIVE_MESSAGE_STATE),
            activeMessages: this.isActiveState(ActiveMessagesConstants.ACTIVE_MESSAGE_STATE),
            adsbuying: this.isActiveState(AdsBuyingConstants.ADS_BUYING_STATE),
            clicktracker: this.isActiveState(ClickTrackerConstants.CLICK_TRACKER_STATE),
            icebreaker: this.isActiveState(ClickTrackerConstants.ICEBREAKER_STATE),
            conversationSettings: this.isActiveState(ClickTrackerConstants.CONVERSATION_SETTINGS_STATE),
            conversationSettingsConnections: this.isActiveState(ClickTrackerConstants.CONVERSATION_SETTINGS_CONNECTIONS_STATE),
            conversationSettingsEvents: this.isActiveState(ClickTrackerConstants.CONVERSATION_SETTINGS_EVENTS_STATE),
        };
    }
    isActiveState(menuStateName) {
        return this.$state.current.name === menuStateName;
    }
    async checkFeatures() {
        this.activeMessageScreenEnabled = await ActiveMessagesFeatures.isActiveMessageScreenEnabled();
        this.clickTrackerEnabled = await ClickTrackerFeatures.isClickTrackerEnabled();
        this.smartIcebreakerEnabled = await ClickTrackerFeatures.IsSmartIcebreakerEnabled();
        this.adsbuyingEnabled = await AdsBuyingFeatures.isAdsBuyingEnabled();
        this.journeyEnabled = await JourneyFeatures.isJourneyEnabled(this.application.shortName);
        this.clickTrackerNews = await ClickTrackerFeatures.isClickTrackerNews();
        this.showWhatsAppGroupView = await GroupsFeatures.isShowWhatsAppGroupViewEnabled();
        this.isHideScheduler = await ActiveMessagesFeatures.isHideScheduler();
        this.isMenuRedesignEnabled = await GrowthFeatures.isMenuRedesignEnabled();
        this.isStilingueMenuEnabled = await GrowthFeatures.IsStilingueMenuEnabled();
        this.isSendMessageMenuEnabled = await ActiveMessagesFeatures.isSendMessagesMenuEnabled();
        this.isActiveMessagesMenuEnabled = await ActiveMessagesFeatures.isActiveMessageMenuEnabled();
        this.isPaymentsReportFeatureEnabled = await GrowthFeatures.isPaymentsReportFeatureEnabled();
        this.menuTitle = this.isHideScheduler
            ? await this.$translate('growth.activeMessages.titleDefault')
            : await this.$translate('growth.activeMessages.title');
    }
    async trackSchedulerOpened() {
        this.SegmentService.createApplicationTrack({
            trackEvent: GROWTH_SCHEDULER_OPENED,
            application: this.application,
        });
    }
    async trackWhatsAppGroupsOpened() {
        this.SegmentService.createApplicationTrack({
            trackEvent: GROWTH_WHATSAPP_GROUPS_OPENED,
            application: this.application,
        });
    }
    async trackSmartIcebreakerOpened() {
        this.SegmentService.createApplicationTrack({
            trackEvent: GROWTH_ICEBREAKER_CLICKED,
            application: this.application,
        });
    }
}
GrowthController.$inject = ['application', 'GrowthSegmentService', 'SegmentService', '$translate', '$state', '$scope', 'LoadingService'];
